export default __webpack_public_path__ + "static/media/PY.90e0e1a5.svg";